<template>
  <div class="page-content animate__animated animate__fadeIn">
    <div class="border-bottom" style="margin-top:0;">
      <!-- 顶部搜索框 -->
      <div>
        <el-form :inline="true" :model="queryParams" class="demo-form-inline">
          <el-form-item label="线路名称">
            <el-input v-model="queryParams.circuitName" placeholder="请输入线路名称进行查询" class="form-item-width"
              clearable></el-input>
          </el-form-item>

          <div class="btn-boxs">
            <div>
              <el-button icon="el-icon-plus" type="primary" @click="handlecircuitAdd">新 增</el-button>
              <el-button :disabled="!multipleSelection.length" icon="el-icon-delete" type="danger"
                @click="batchDelete">批量删除</el-button>
            </div>
            <div>
              <el-button icon="el-icon-search" type="primary" @click="onSearch">查 询</el-button>
              <el-button icon="el-icon-refresh" @click="onReset">重 置</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="margin-top" style="margin-bottom:0;margin-top:15px">
      <!-- 表格组件 -->
      <el-table :data="tableData" v-loading="tableLoading" border row-key="deptId" default-expand-all
        :tree-props="{ children: 'children' }" highlight-current-row max-height="447"
        :header-cell-style="{ background: '#fafafa', color: '#606266', fontSize: '14px' }"
        @selection-change="handleSelectionChange">
        <!-- 多选 -->
        <el-table-column type="selection" width="55"></el-table-column>
        <!-- 序号列 -->
        <el-table-column align="center" type="index" label="序号" width="50"></el-table-column>
        <!-- 动态生成其他列 -->
        <el-table-column align="center" v-for="tab in tableTitle" :key="tab.code" :label="tab.name"
          show-overflow-tooltip :width="tab.width">
          <template slot-scope="scope">
            <span v-if="tab.code === 'classify'">{{ scope.row.classify === '1' ? '高铁' : '普铁' }}</span>
            <span v-else-if="tab.code === 'type'">{{ circuitMaping[scope.row.type] }}</span>
            <span v-else>{{ scope.row[tab.code] }}</span>
          </template>
        </el-table-column>
        <el-table-column align=" center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="updateData(scope.row)" class="update-btn">修改</el-button>
            <el-button style="color:red" type="text" @click="deleteData(scope.row)" class="update-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <div>
        <Pagination background :total="pageParams.total" :page="pageParams.pageNum" :limit="pageParams.pageSize"
          @pagination="onChangePages" />
      </div>
    </div>
    <!-- 添加 修改角色 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisble" width="30%" @close="handleDialogClose">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="线路名称" prop="circuitName">
          <el-input v-model="form.circuitName" autocomplete="off" placeholder="请输入线路名称"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-select v-model="form.type" placeholder="请选择类型">
            <el-option v-for="item in circuitTypeList" :key="item.dictCode" :label="item.dictLabel"
              :value="item.dictValue"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="线路类型" prop="classify">
          <el-select clearable v-model="form.classify" placeholder="请选择线路类型">
            <el-option label="高铁" value="1"></el-option>
            <el-option label="普铁" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="线路别名" prop="remark">
          <el-input v-model="form.remark"  placeholder="请输入线路别名"  type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :icon="dialogTitle === '新增' ? 'el-icon-plus' : 'el-icon-edit'" type="primary"
          @click="submitForm('form')">{{ dialogTitle === '新增' ? '立即添加' : '立即修改' }}</el-button>
        <el-button icon="el-icon-refresh" @click="resetForm('form')">重 置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { getCircuitList,circuitAdd,circuitById,updeteCircuit, deleteCircuit} from "@/api/data-service/line.js";
import { getCircuitType } from "@/api/admin-service/dictDataType.js";
export default {
  components: {
    Pagination
  },
  data() {
    return {
      tableLoading: false,
      form: {
        circuitName: "", //线路名称
        type: "",
        classify: "",
        remark:""
      },
      rules: {
        circuitName: [
          { required: true, message: "请填写线路名称", trigger: "blur" }
        ],
        type: [{ required: true, message: "请填写类型", trigger: "blur" }],
        classify: [{ required: true, message: "请填写线路类型", trigger: "blur" }],
      },
      dialogTitle: "",
      updateId: "", //修改数据需要的id
      dialogFormVisble: false,
      // 表格数据
      tableData: [],
      // 表格标题数组
      tableTitle: [
        { name: "线路名称", code: "circuitName", width: "" },
        { name: "类型", code: "type", width: "" },
        { name: "线路类型", code: "classify", width: "" },
        { name: "线路别名", code: "remark", width: "" },
      ],

      pageParams: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      queryParams: {
        circuitName: "" //线路名称
      },
      multipleSelection: [],
      circuitTypeList: [],
      circuitMaping: {}
    };
  },
  mounted() {
    this.onGetDataList();
    this.queryCircuitTypeList();
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    queryCircuitTypeList() {
      getCircuitType({ type: "sys_circuit_type" }).then(res => {
        this.circuitTypeList = res?.data || [];
        // 创建一个映射对象
        const circuitMaping = this.circuitTypeList.reduce((map, item) => {
          map[item.dictValue] = item.dictLabel; // 将 dictLabel 作为键，dictValue 作为值
          return map;
        }, {});
        this.circuitMaping = circuitMaping;
      });
    },
    batchDelete() {
      this.$confirm(`提示，确定要删除选中的这些数据吗？`, {
        title: "提示",
        showCancelButton: true,
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
        // 为按钮添加图标并设置为 mini 尺寸
        confirmButtonClass: "el-icon-check el-button--mini", // 确定按钮的图标和尺寸
        cancelButtonClass: "el-icon-close el-button--mini" // 取消按钮的图标和尺寸
      })
        .then(() => {
          // 使用 map() 来获取 circuitId 组成的数组
          const ids = (this.multipleSelection || []).map(
            item => item.circuitId
          );
          deleteCircuit({ ids }).then(res => {
            if (res?.data) {
              this.$message.success(res.msg || "删除成功");
              this.onGetDataList();
            }
          });
        })
        .catch(error => {
          console.log(error);
          // 取消删除时显示提示
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    addData() {
      this.dialogTitle = "新增";
      this.dialogFormVisble = true;
    },
    // 增 / 改
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const formData = { ...this.form };
          delete formData.circuitId; // 清除 circuitId
          if (this.dialogTitle === "新增") {
            circuitAdd(formData).then(res => {
              if (res.data) {
                this.$message.success(res.msg || "新增成功！");
                this.dialogFormVisble = false;
                this.onGetDataList();
              }
            });
          } else {
            updeteCircuit({
              ...this.form,
              circuitId: this.updateId
            }).then(r => {
              if (r.data) {
                this.$message.success(r.msg || "修改成功！");
                this.dialogFormVisble = false;
                this.onGetDataList();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删
    deleteData(row) {
      this.$confirm(`提示，确定要删除该条数据吗？`, {
        title: "提示",
        showCancelButton: true,
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
        // 为按钮添加图标并设置为 mini 尺寸
        confirmButtonClass: "el-icon-check el-button--mini", // 确定按钮的图标和尺寸
        cancelButtonClass: "el-icon-close el-button--mini" // 取消按钮的图标和尺寸
      })
        .then(() => {
          deleteCircuit({ ids: [row.circuitId] }).then(res => {
            if (res?.data) {
              this.$message.success(res.msg || "删除成功");
              this.onGetDataList();
            }
          });
        })
        .catch(error => {
          console.log(error);
          // 取消删除时显示提示
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 改
    updateData(row) {
      this.dialogTitle = "修改";
      this.dialogFormVisble = true;
      this.updateId = row.circuitId;
      circuitById({ id: row.circuitId }).then(res => {
        Object.assign(this.form, res?.data);
      });
    },
    // 查
    onGetDataList() {
      this.tableLoading = true;
      getCircuitList({
        ...this.queryParams,
        ...this.pageParams
      })
        .then(res => {
          const { records, total } = res.data;
          this.tableData = records;
          this.pageParams.total = total;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },

    handlecircuitAdd() {
      this.dialogTitle = "新增";
      this.dialogFormVisble = true;
    },
    handleDialogClose() {
      this.resetForm("form");
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 查询
    onSearch() {
      this.onGetDataList();
    },
    // 重置
    onReset() {
      this.pageParams.pageNum = 1;
      this.pageParams.pageSize = 10;
      this.queryParams.circuitName = "";
      this.onSearch();
    },
    // 分页方法
    onChangePages(pageInfo) {
      this.pageParams.pageNum = pageInfo.page;
      this.pageParams.pageSize = pageInfo.limit;
      this.onGetDataList();
    }
  }
};
</script>
<style lang="less" scoped>
.analyse-container {
  display: flex;
  height: 95vh;
}

.form-item-width {
  width: 250px;
}

.right-btns {
  position: absolute;
  right: 20px !important;
}

.border-bottom {
  border-bottom: 1px solid #e2e2e4;
}

.margin-top {
  margin-top: -15px;
}

.custom-tree-node {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  .tree-node-label {
    font-size: 12px;
    font-weight: bold;
  }
}
</style>
